/* global WebView, ViewController*/
const personalInformationPortalWidgetController = require("./personalInformationPortalWidgetController");
var portalController = new ViewController({
    directory : "views/portal",
    name: "portal",
    container: "main",
    route: "portal"
}) ;

portalController.searchRecords = function(callback){
    this.api.portal.results("portalDoc", "getDocs", callback) ;
} ;

portalController.prepareDataOnEnter = function(data, callback){
    var widgets = [] ;
    var calls = [] ;
    this.api.public.getPortalModule(function(err, modules){
        if(err){ return callback(err) ;}
        if (!this.api.currentUser.employee_id) {
            // loading widgets of costumer portal
            modules.forEach(function(m){
                window.IZEE_MODULES.some(function(module){
                    if(module.portal && module.name === m.module_name){
                        if(typeof(module.portal) === "function"){
                            calls.push(function(cb){
                                module.portal(function(err, widgetControllers){
                                    if(err){ return cb() ; }
                                    widgetControllers.forEach(function(p){
                                        if(p.viewOptions.portalType === "widget"){
                                            window.app.registerController(p) ;
                                            widgets.push({
                                                index : widgets.length,
                                                title: p.title,
                                                icon: p.icon,
                                                controller: p
                                            }) ;
                                        }
                                    }) ;
                                    cb() ;
                                }) ;
                            });
                        }else{
                            module.portal.forEach(function(p){
                                if(p.viewOptions.portalType === "widget"){
                                    window.app.registerController(p) ;
                                    widgets.push({
                                        index : widgets.length,
                                        title: p.title,
                                        icon: p.icon,
                                        controller: p
                                    }) ;
                                }
                            }) ;
                        }
                        return true ;
                    }
                }) ;
            }) ;
        }
        // loading widgets of employee portal
        if (this.api.currentUser.employee_id) {
            widgets.push({
                index: widgets.length,
                title: WebView.tr("portal.personalInformation"),
                icon: "fas fa-id-card",
                controller: personalInformationPortalWidgetController
            });
        }

        this.api.db.multiread({
            hr_employee: { searchFirst: {
                id : this.api.currentUser.employee_id
            }}
        }, function(err, reads){    
            if(err){ return callback(err) ;}

            let currentEmployee = reads.hr_employee || {name: "Unknown Employee"} ;
            
            WebView._asyncSeries(calls, function(err){
                if(err){ return callback(err) ; }
                return callback(null, {
                    widgets: widgets,
                    currentEmployee: currentEmployee,
                    company_id: currentEmployee.company_id,
                    iz_estab_id: currentEmployee.iz_estab_id,
                    iz_agency_id: currentEmployee.iz_agency_id
                }) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

portalController.onRender = function(){
    this.data.widgets.forEach(function(widget, i){
        var elContainer = this.view.EL.widgetContainer.realEls[i] ;
        widget.controller.view.container = elContainer;
        widget.controller.view.options.container = elContainer;
        widget.controller.viewOptions.container = elContainer;
        widget.controller.enter() ;
    }.bind(this)) ;
} ;

portalController.onChangePassword = function(){
    this.view.longTask(function(done){
        var viewChange = new WebView("views/main", "changePassword") ;
        viewChange.openInPopup({
            title: WebView.tr("main.changePassword")
        }, function(){
            done() ;
        }.bind(this))  ;
        viewChange.on("cancel",function(){
            viewChange.close() ;
        }.bind(this)) ;
        viewChange.on("validate",function(){
            var data = viewChange.getData() ;
            this.api.auth.changeUserPassword(data.passwordOld, data.passwordNew, function(err, success){
                if(err){ return done(err);}
                if(!success){
                    return done(WebView.tr("main.wrongPassword")) ;
                }
                viewChange.close() ;
                WebView.info(WebView.tr("main.changePasswordSuccess"), done) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


portalController.onLogout = function(){
    this.view.longTask(function(done){
        this.api.auth.logout(function(err){
            if(err){ return done(err);}
            this.navigate("/portal") ;
            portalController.refresh() ;
            done() ;
            document.location.reload() ;
        }.bind(this)) ;
    }.bind(this));
} ;

module.exports = portalController ;